import { render, staticRenderFns } from "./PopupCouponExchangeDuplicate.vue?vue&type=template&id=2d97d60c&scoped=true&"
import script from "./PopupCouponExchangeDuplicate.vue?vue&type=script&lang=js&"
export * from "./PopupCouponExchangeDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./PopupCouponExchangeDuplicate.vue?vue&type=style&index=0&id=2d97d60c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97d60c",
  null
  
)

export default component.exports